import React from 'react';
import A4Page from '../components/A4Page';
import { REPORT_TABS } from '../utils/reportConstants';
import { useReports } from '../ReportsProvider';

const ContentsTab = () => {
  const { isSectionIncluded } = useReports();
  // Included tabs only, excluding cover-page and contents
  const contentTabs = REPORT_TABS.filter(tab => 
    tab.id !== 'cover-page' && tab.id !== 'contents' && isSectionIncluded(tab.id)
  );

  return (
    <A4Page pageNumber={1}>
      <div style={{ 
        width: '190mm', 
        height: '277mm', 
        display: 'flex', 
        flexDirection: 'column',
        padding: '10mm',
        boxSizing: 'border-box'
      }}>
        
        {/* Contents Header - More compact */}
        <div style={{ marginBottom: '8mm' }}>
          <h1 style={{ 
            fontSize: '20px', 
            fontWeight: 'bold', 
            color: '#1e3a8a', 
            textAlign: 'center',
            margin: '0 0 5mm 0',
            textTransform: 'uppercase',
            letterSpacing: '2px'
          }}>
            TABLE OF CONTENTS
          </h1>
          <div style={{
            height: '2px',
            background: 'linear-gradient(to right, #1e3a8a, #1d4ed8)',
            margin: '0 auto',
            width: '80mm'
          }}></div>
        </div>

        {/* Contents Table */}
        <div style={{ flex: 1 }}>
          <table style={{ 
            width: '100%', 
            borderCollapse: 'collapse',
            fontSize: '14px'
          }}>
            <thead>
              <tr>
                <th style={{ 
                  textAlign: 'left', 
                  padding: '8px 0', 
                  borderBottom: '2px solid #e5e7eb',
                  color: '#374151',
                  fontWeight: '600',
                  width: '85%'
                }}>
                  Section
                </th>
                <th style={{ 
                  textAlign: 'right', 
                  padding: '8px 0', 
                  borderBottom: '2px solid #e5e7eb',
                  color: '#374151',
                  fontWeight: '600',
                  width: '15%'
                }}>
                  Page
                </th>
              </tr>
            </thead>
            <tbody>
              {contentTabs.map((tab, index) => (
                <tr key={tab.id} data-toc-section={tab.id}>
                  <td style={{ 
                    padding: '10px 0', 
                    borderBottom: '1px solid #f3f4f6',
                    color: '#111827'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span style={{ marginRight: '8px', fontSize: '16px' }}>
                        {tab.icon}
                      </span>
                      <span style={{ fontWeight: '500' }}>
                        {tab.name}
                      </span>
                    </div>
                  </td>
                  <td style={{ 
                    padding: '10px 0', 
                    borderBottom: '1px solid #f3f4f6',
                    color: '#6b7280',
                    textAlign: 'right',
                    fontWeight: '500'
                  }}>
                    <span data-toc-page={tab.id}>—</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </A4Page>
  );
};

export default ContentsTab;